import {
  SEND_COMMENT_REQUEST,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,
  SEND_COMMENT_LIMIT_FAILURE,

  GET_COMMENT_REQUEST,
  GET_COMMENT_SUCCESS,
  GET_COMMENT_FAILURE,
  GET_COMMENT_LIST_SUCCESS,
  RESET_COMMENT_LIST,

  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,

  BLOCK_USER_REQUEST,
  BLOCK_USER_SUCCESS,
  BLOCK_USER_FAILURE,

  UNBLOCK_USER_REQUEST,
  UNBLOCK_USER_SUCCESS,
  UNBLOCK_USER_FAILURE,

  COMMENT_FORBID_ALLOW_REQUEST,
  COMMENT_FORBID_ALLOW_SUCCESS,
  COMMENT_FORBID_ALLOW_FAILURE,

  LIKE_OR_UNLIKE_COMMENT_REQUEST,
  LIKE_OR_UNLIKE_COMMENT_SUCCESS,
  LIKE_OR_UNLIKE_COMMENT_FAILURE,

} from 'Store/constants';

import EnvironmentManager from 'Utils/environmentManager';
import { likeOrUnlikeCommentStoreStateChanger } from 'Utils/tribunStoreHelpers';

const initialState = {
  data: {},
  commentData: {
    data: {},
    isLoading: false,
    error: null,
    lastPage: false
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEND_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null, limitError: null };
    case SEND_COMMENT_SUCCESS:
      return { ...state, data: {
        ...action.payload
      }, isLoading: false, error: null };
    case SEND_COMMENT_FAILURE:
      return { ... state, isLoading: false, error: action.payload };
    case SEND_COMMENT_LIMIT_FAILURE:
      return { ...state, isLoading: false, limitError: action.payload };

    case GET_COMMENT_REQUEST:
      return { ...state,
        commentData: {
          ...state.commentData,
          isLoading: true, error: null
        }
      };

    case RESET_COMMENT_LIST:
      return { ...state,
        commentData: {
          data: {}
        }
      };
      
    case GET_COMMENT_SUCCESS:
      return { ...state,
        commentData: {
          ...state.commentData,
          data: { ...state.commentData.data, [action.payload.feedId]: action.payload.data },
          isLoading: false, error: null, lastPage: false
        }
      };
    case GET_COMMENT_LIST_SUCCESS:
      return { ...state,
        commentData: {
          ...state.commentData,
          data: { ...state.commentData.data, [action.payload.feedId]:
            !state.commentData.data[action.payload.feedId] ? action.payload.data
              :  state.commentData.data[action.payload.feedId].concat(action.payload.data)
          },
          isLoading: false, error: null, lastPage: action.payload.lastPage
        }
      };
    case GET_COMMENT_FAILURE:
      return { ... state,
        commentData: {
          ...state.commentData,
          isLoading: false, error: action.payload, lastPage: action.lastPage
        }
      };

    case DELETE_COMMENT_REQUEST:
      return { ...state, deleteToastMessage: null };
    case DELETE_COMMENT_SUCCESS:
      return { ...state, deleteToastMessage: EnvironmentManager.getMessageText({ key: 'tribun_comment_delete_success' })  };
    case DELETE_COMMENT_FAILURE:
      return { ... state, deleteToastMessage: null };

    case BLOCK_USER_REQUEST:
      return { ...state,
        commentData: {
          ...state.commentData,
          isLoading: true, error: null
        }
      };
    case BLOCK_USER_SUCCESS: {
      const { feedId, commentId, userId } = action.payload;

      if (!feedId || !commentId) {
        return state;
      }
    
      return { ... state,
        commentData: {
          ...state.commentData,
          data: { ...state.commentData.data, blockedByUser: true,
            [feedId]: state.commentData.data[feedId].map(comment => {
              if (comment.feedId === feedId && comment.user.userId === userId) {
                return { ...comment, user: { ...comment.user, blockedByUser: true } };
              } else {
                return comment;
              }
            }) },
          isLoading: false, error: null
        }
      };
    }
    case BLOCK_USER_FAILURE:
      return { ...state,
        commentData: {
          ...state.commentData,
          data: { blockedByUser: null },
          isLoading: false, error: action.payload
        }
      };
      
    case UNBLOCK_USER_REQUEST:
      return { ...state,
        commentData: {
          ...state.commentData,
          isLoading: true, error: null
        }
      };
    case UNBLOCK_USER_SUCCESS:
    {
      const { feedId, commentId, userId } = action.payload;

      if (!feedId || !commentId) {
        return state;
      }

      return { ... state,
        commentData: {
          ...state.commentData,
          data: { ...state.commentData.data, blockedByUser: false,
            [feedId]: state.commentData.data[feedId].map(comment => {
              if (comment.feedId === feedId && comment.user.userId === userId) {
                return { ...comment, user: { ...comment.user, blockedByUser: false } };
              } else {
                return comment;
              }
            }) },
          isLoading: false, error: null
        }
      };
    }

    case UNBLOCK_USER_FAILURE:
      return { ... state,
        commentData: {
          ...state.commentData,
          data: { blockedByUser: null },
          isLoading: false, error: action.payload
        }
      };

    case COMMENT_FORBID_ALLOW_REQUEST:
      return { ...state, forbidToastMessage: null };
    case COMMENT_FORBID_ALLOW_SUCCESS:
      return { ...state, forbidToastMessage: true, forbidFeedId: action.feedId };
    case COMMENT_FORBID_ALLOW_FAILURE:
      return { ...state, forbidToastMessage: null };

    case  LIKE_OR_UNLIKE_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case  LIKE_OR_UNLIKE_COMMENT_SUCCESS:
    {
      state.data = likeOrUnlikeCommentStoreStateChanger(state, action);
      return { ...state, isLoading: false, error: null };
    }
    case  LIKE_OR_UNLIKE_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};